import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
  base: '/',
  routes: [
    {
      path: '/',
      name: 'products',
      components: {
        default: () => import('@/pages/Products.vue'),
      },
    },
    {
      path: '/help-me-choose',
      name: 'main',
      components: {
        default: () => import('@/pages/HelpMeChoose.vue'),
      },
    },
    {
      path: '*',
      name: 'placeholder',
      components: {
        default: () => import('@/pages/Placeholder.vue'),
      },
    },
  ],
});

export default router;
